<div class="vw-100 d-flex direction-column">
  <app-ordered-header-list [headerItems]="storeConfigHeader" (orderChangeEvent)="orderChange($event)">
    <ng-container buttonSpace>
      <div button class="d-flex justify-flex-end flex-1">
        <button type="button" class="btn-register h-28 w-130" (click)="openStoreDialog()">
          <span class="d-flex justify-center align-center">
            <app-svg-icon src="../../../../assets/icons/vector-comissao.svg"
                          color="white"
                          width="12px"
                          height="12px"
                          class="mr-10">
            </app-svg-icon>
            <span>Cadastrar</span>
          </span>
        </button>
      </div>
    </ng-container>
  </app-ordered-header-list>

  <ng-container *ngFor="let config of storeConfigs">
    <app-card-configuracoes [cardType]="DialogEmailTypeEnum.StoreConfig"
                            [storeConfig]="config"
                            (updateEvent)="handleOpenDialogEdit(config)"
                            (deleteEvent)="handleOpenDialogDelete(config)"></app-card-configuracoes>
  </ng-container>

  <ng-container *ngIf="storeConfigs.length === 0">
    <app-empty-card class="mt-10"
                    text="Não há configurações cadastradas"></app-empty-card>
  </ng-container>

  <ng-container *ngIf="storeConfigs.length > 0">
    <app-pagination-footer (paginationTrigger)="handlePagination($event)"
                           [count]="count"></app-pagination-footer>
  </ng-container>
</div>
